<template>
  <div class="content_box UBO">
    <!-- 工具栏 插槽-->

    <div class="header" style="background: #603c2c">
      <Header @onSearch="onSearch" :themeColor="'#603C2C'">
        <!-- 工具栏 -->
        <Tollbar
          class="header_menu_box"
          :list="tollbarList"
          :sortList="sortList"
          :conditionsList="conditionsList"
          :selectList="selectList"
          :moreTool="moreToolbarList"
          type="1"
          theme="1"
          :isShowSearch.sync="isShowSearch"
          :isShowSelect.sync="isShowSelect"
          @onClearSearch="clearParams"
          @onChangeSort="onChangeSort"
          @menuClick="menuClick"
        ></Tollbar>
      </Header>
    </div>
    <div class="content_wrap">
      <div class="wrap_search_box" v-show="isShowSearch" v-loading="loading">
        <el-collapse v-model="openMenu" ref="collapseItem">
          <el-collapse-item
            v-if="isCompanyOrProduct"
            title=""
            name="0"
            class="first_item"
          >
            <template slot="title">
              <span>{{ $t("Relationship.HsCodeProduct") }}</span>
              <span class="clear_all" @click.stop="clearParams">
                <i class="iconfont icon-qingchu" />{{
                  $t("Relationship.ClearAll")
                }}
              </span>
            </template>

            <el-select
              clearable
              v-model="searchParams.hsCode"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              placeholder="Select Hs Code / Product"
              @change="(val) => onChangeParams(val, 'hsCode')"
            >
              <el-option
                v-for="(item, index) in productList"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
                <OverflowTooltip :tip="`${item.value}-${item.name}`" />
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item
            :title="$t('Relationship.CompanyName')"
            v-if="isCompanyOrProduct"
            name="1"
          >
            <template slot="title">
              <span>{{ $t("Relationship.CompanyName") }}</span>
              <span
                v-if="!isCompanyOrProduct"
                class="clear_all"
                @click.stop="clearParams"
              >
                <i class="iconfont icon-qingchu" />{{
                  $t("Relationship.ClearAll")
                }}
              </span>
            </template>

            <!-- <el-select
              clearable
              v-model="searchParams.companyName"
              filterable
              class="search-select-con"
              popper-class="new-search-select"
              placeholder="Enter Company Name"
              remote
              :popper-append-to-body="true"
              :remote-method="companyMethod"
              @change="(val) => onChangeParams(val, 'companyName')"
              @visible-change="onFocusCompany"
            > -->
            <el-select
              clearable
              v-model="searchParams.companyName"
              filterable
              popper-class="new-search-select"
              :placeholder="$t('Home.inputCompany')"
              :popper-append-to-body="true"
              @change="(val) => onChangeParams(val, 'companyName')"
            >
              <el-option
                v-for="(item, index) in companyList"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
                <div class="flex-between-center">
                  <OverflowTooltip :tip="item.name" />
                  <span class="select-num">{{ item.count | FilterNum }}</span>
                </div>
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item
            v-if="isCompanyOrProduct"
            :title="$t('Relationship.ImportExport')"
            name="2"
          >
            <el-checkbox-group
              v-model="searchParams.importOrExport"
              @change="(val) => onChangeParams(val, 'importOrExport')"
            >
              <el-checkbox
                :label="ops.value"
                v-for="(ops, index) in importOrExportList"
                :key="index"
              >
                <span class="check_label">{{ ops.name }}</span>
                <span class="check_label_count">{{
                  ops.count | FilterNum
                }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item
            :title="$t('Relationship.Country')"
            name="3"
            class="first_item"
          >
            <template slot="title">
              <span>{{ $t("Relationship.Country") }}</span>
              <span
                v-if="!isCompanyOrProduct"
                class="clear_all"
                @click.stop="clearParams"
              >
                <i class="iconfont icon-qingchu" />{{
                  $t("Relationship.ClearAll")
                }}
              </span>
            </template>
            <el-select
              clearable
              v-model="searchParams.country"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              :placeholder="$t('Home.selectCountry')"
              @change="(val) => onChangeParams(val, 'country')"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.name"
                :value="item.value"
                class="el_cus_select"
              >
                <span class="check_label"> {{ item.name }}</span>
                <span class="check_label_count">{{
                  item.count | FilterNum
                }}</span>
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item :title="$t('Relationship.Industry')" name="4">
            <el-cascader
              popper-class="el_cascader"
              v-model="searchParams.industry"
              :options="industryList"
              clearable
              filterable
              :emitPath="false"
              @change="(val) => onChangeParams(val, 'industry')"
            >
              <template slot-scope="{ node, data }">
                <div class="el_cus_select">
                  <span class="check_label">
                    <OverflowTooltip :tip="data.label" />
                  </span>
                  <span v-if="node.isLeaf" class="check_label_count">{{
                    data.count | FilterNum
                  }}</span>
                </div>
              </template>
            </el-cascader>
          </el-collapse-item>
          <el-collapse-item :title="$t('Relationship.CompanyType')" name="5">
            <el-checkbox-group
              v-model="searchParams.companyType"
              @change="(val) => onChangeParams(val, 'companyType')"
            >
              <el-checkbox
                :label="ops.value"
                v-for="(ops, index) in companyTypeList"
                :key="index"
              >
                <span class="check_label">
                  <OverflowTooltip :tip="ops.name" />
                </span>
                <span class="check_label_count">{{
                  ops.count | FilterNum
                }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item :title="$t('Relationship.CompanySize')" name="6">
            <el-checkbox-group
              v-model="searchParams.companySize"
              @change="(val) => onChangeParams(val, 'companySize')"
            >
              <el-checkbox
                :label="ops.value"
                v-for="(ops, index) in companySizeList"
                :key="index"
              >
                <span class="check_label">{{ ops.name }}</span>
                <span class="check_label_count">{{
                  ops.count | FilterNum
                }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item :title="$t('Relationship.CompanyStatus')" name="7">
            <el-checkbox-group
              v-model="searchParams.companyStatus"
              @change="(val) => onChangeParams(val, 'companyStatus')"
            >
              <el-checkbox
                :label="ops.value"
                v-for="(ops, index) in companyStatusList"
                :key="index"
              >
                <span class="check_label">{{ ops.name }}</span>
                <span class="check_label_count">{{
                  ops.count | FilterNum
                }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item :title="$t('Relationship.ListingInfo')" name="8">
            <el-checkbox-group
              v-model="searchParams.listedCompany"
              @change="(val) => onChangeParams(val, 'listedCompany')"
            >
              <el-checkbox
                :label="ops.value"
                v-for="(ops, index) in listedCompanyList"
                :key="index"
              >
                <span class="check_label">{{ ops.name }}</span>
                <span class="check_label_count">{{
                  ops.count | FilterNum
                }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>
          <el-collapse-item
            :title="$t('Relationship.YearsinBusiness')"
            name="9"
          >
            <el-checkbox-group
              v-model="searchParams.yearsInBusiness"
              @change="(val) => onChangeParams(val, 'yearsInBusiness')"
            >
              <el-checkbox
                :label="ops.value"
                v-for="(ops, index) in yearsInBusinessList"
                :key="index"
              >
                <span class="check_label">{{ ops.name }}</span>
                <span class="check_label_count">{{
                  ops.count | FilterNum
                }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div class="wrap_con_box table_only">
        <div class="new-content-total">
          Found over {{ total | FilterNum }}
          <span v-if="$route.query.keyword">"{{ $route.query.keyword }}"</span>
          results
        </div>
        <el-table
          v-if="isCompanyOrProduct"
          class="risk_table"
          :data="tableData"
          height="100%"
          v-loading="loading"
          ref="tableRefProduct"
          v-loadmore="handleScroll"
          :row-key="(row) => row.aaa_id"
        >
          <el-table-column
            v-if="isShowSelect"
            :resizable="false"
            type="selection"
            reserve-selection
            align="center"
            class-name="table_check_row"
            width="40"
          />
          <el-table-column
            prop="hsCode"
            align="center"
            :label="$t('Relationship.HSCode')"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="productName"
            align="center"
            :label="$t('Relationship.Product')"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="companyName"
            :label="$t('Relationship.CompanyName')"
            min-width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="flex_center_start_box">
                <img
                  class="country_img"
                  :src="
                    require('./../../../static' +
                      getCountryImgUrl(scope.row.countryCode))
                  "
                />
                <span
                  class="link_hover_text"
                  @click="
                    goDetail({
                      aaa_id: scope.row.aaaid,
                      name: scope.row.companyName,
                    })
                  "
                >
                  {{ scope.row.companyName }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ieEnum"
            align="center"
            :label="$t('Relationship.ImportExport')"
            min-width="80"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="countryName"
            align="center"
            :label="$t('Relationship.Country')"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="industryDescEn"
            align="center"
            :label="$t('Relationship.Industry')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="companyType"
            align="center"
            :label="$t('Relationship.CompanyType')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="companySize"
            align="center"
            :label="$t('Relationship.CompanySize')"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="companyStatus"
            align="center"
            :label="$t('Relationship.CompanyStatus')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="listingInfo"
            align="center"
            :label="$t('Relationship.ListingInfo')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="incorporationDate"
            align="center"
            :label="$t('Relationship.IncDate')"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-table
          v-else
          class="risk_table"
          :data="tableData"
          height="100%"
          v-loading="loading"
          ref="tableRefCompany"
          v-loadmore="handleScroll"
          :row-key="(row) => row.aaa_id"
          @expand-change="onRowExpansion"
          :expand-row-keys="expandedRowKeys"
          @selection-change="onSelectionChange"
        >
          <el-table-column
            v-if="isShowSelect"
            :resizable="false"
            type="selection"
            reserve-selection
            align="center"
            class-name="table_check_row"
            width="40"
          />
          <el-table-column
            type="expand"
            align="center"
            width="25"
            :resizable="false"
          >
            <template slot-scope="scope">
              <div class="expand_table_box" v-loading="childLoading">
                <el-table
                  class="risk_table child_no_header_table"
                  :data="childTableData"
                  height="100%"
                  ref="tableRefChild"
                  :row-key="(row) => row.aaa_id"
                >
                  <el-table-column
                    prop="entname"
                    :label="$t('Relationship.CompanyName')"
                    min-width="220"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <div class="flex_center_start_box">
                        <img
                          class="country_img"
                          :src="
                            require('./../../../static' +
                              getCountryImgUrl(scope.row.company_country))
                          "
                        />
                        <span
                          class="link_hover_text"
                          @click="
                            goDetail({
                              aaa_id: scope.row.aaa_id,
                              name: scope.row.company_name_en,
                            })
                          "
                        >
                          {{ scope.row.company_name_en }}</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="company_country"
                    align="center"
                    :label="$t('Relationship.Country')"
                    min-width="110"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="isic_en"
                    align="center"
                    :label="$t('Relationship.Industry')"
                    min-width="110"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="company_type_en"
                    align="center"
                    :label="$t('Relationship.CompanyType')"
                    min-width="110"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="scale_en"
                    align="center"
                    :label="$t('Relationship.CompanySize')"
                    min-width="110"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="status_en"
                    align="center"
                    :label="$t('Relationship.CompanyStatus')"
                    min-width="150"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="listing_status_en"
                    align="center"
                    :label="$t('Relationship.ListingInfo')"
                    min-width="110"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="incorporation_date"
                    align="center"
                    :label="$t('Relationship.YearsinBusiness')"
                    min-width="150"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                </el-table>
                <div class="pagination_box">
                  <Page
                    keyword="xxxx"
                    :fontColor="'#B44818'"
                    :total="childParam.total"
                    :pageSize="childParam.pageSize"
                    :currentPage="childParam.page"
                    @onPageChange="onChangePage"
                  ></Page>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="company_name_en"
            :label="$t('Relationship.CompanyName')"
            min-width="200"
          >
            <template slot-scope="scope">
              <div class="flex_center_start_box">
                <img
                  class="country_img"
                  :src="
                    require('./../../../static' +
                      getCountryImgUrl(scope.row.company_country))
                  "
                />
                <span
                  class="link_hover_text"
                  @click="
                    goDetail({
                      aaa_id: scope.row.aaa_id,
                      name: scope.row.company_name_en,
                    })
                  "
                >
                  {{ scope.row.company_name_en }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="company_country"
            align="center"
            :label="$t('Relationship.Country')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="industry_en"
            align="center"
            :label="$t('Relationship.Industry')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="company_type_en"
            align="center"
            :label="$t('Relationship.CompanyType')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="scale_en"
            align="center"
            :label="$t('Relationship.CompanySize')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="status_en"
            align="center"
            :label="$t('Relationship.CompanyStatus')"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="listing_status_en"
            align="center"
            :label="$t('Relationship.ListingInfo')"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="incorporation_date"
            align="center"
            :label="$t('Relationship.IncDate')"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import tools from "@/views/layout/tools.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import Page from "@/views/newLayout/page.vue";
import Header from "@/views/newLayout/header.vue";
import {
  getProductSearch,
  getProductFilter,
  getCompanySearch,
  getCompanyFilter,
  getProductSortByColumns,
} from "@/api/uboApi.js";
import {
  getCollectionList,
  getqueryList,
  getqueryaddList,
  getqueryremoveList,
  sharingInformation,
} from "@/api/userApi";
export default {
  name: "UboList",
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  mixins: [mixins1],
  data() {
    return {
      isCompanyOrProduct: (this.$route.query.selectKey || "") == "Product", //默认检索产品
      searchForm: {
        date: [],
      },
      tableData: [],
      childTableData: [],

      total: 0,
      expandedRowKeys: [], // 当前展开的行的 key
      searchParams: {
        page: 1,
        pageSize: 20,
        companyName: "",
        country: "", //国家
        industry: [], //行业
        hsCode: "", //产品
        importOrExport: [], //导入导出
        companyType: [], //类型
        companySize: [], //规模
        companyStatus: [], //公司状态
        listedCompany: [], //上市状态
        yearsInBusiness: [], //在业年限
        sortColumn: "", //排序字段
        sortType: "DESC", //排序类型
      },
      childParam: {
        branchflag: "",
        page: 1,
        pageSize: 5,
        total: 0,
      },
      productList: [],
      companyList: [],
      countryList: [],
      industryList: [],
      importOrExportList: [],
      companyTypeList: [],
      companySizeList: [],
      companyStatusList: [],
      listedCompanyList: [],
      yearsInBusinessList: [],
      openMenu: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
      sortList: [],
      conditionsList: ["Company Name", "Country", "Record Source"],
      selectList: [],
      isShowSearch: true, //默认展示侧边检索
      isShowSelect: false, // 是否显示复选框
      loading: false, // 加载状态
      hasMore: true, // 是否还有更多数据
      childLoading: false,
    };
  },
  components: {
    tools,
    Tollbar,
    Page,
    Header,
  },
  computed: {
    tollbarList() {
      return [
        {
          icon: "icon-xuanze",
          name: this.$t("Toolbar.Select"),
          disabled: false,
        },
        {
          icon: "icon-bianji1",
          name: this.$t("Toolbar.Edit"),
          disabled: true,
          select: true,
        },
        // {
        //   icon: "icon-filter",
        //   name: "Sort by",
        //   disabled: false,
        //   select: true,
        // },
        {
          icon: "icon-shoucang1",
          name: this.$t("Toolbar.Collect"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: this.$t("Toolbar.Saved"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: this.$t("Toolbar.Compare"),
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: this.$t("Toolbar.Export"),
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: this.$t("Toolbar.Download"),
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: this.$t("Toolbar.Update"),
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: this.$t("Toolbar.Reporterror"),
          disabled: true,
        },
        {
          icon: "icon-saomiao",
          name: this.$t("Toolbar.RiskScanning"),
          disabled: true,
        },
      ];
    },
    moreToolbarList() {
      return [
        {
          icon: "icon-xinyongpingjia",
          name: this.$t("Toolbar.CreditAssessment"),
          disabled: true,
        },
        {
          icon: "icon-shujufenxi1",
          name: this.$t("Toolbar.DataAnalysis"),
          disabled: true,
        },
        {
          icon: "icon-touzizuhe",
          name: this.$t("Toolbar.NewPortfolio"),
          disabled: true,
        },
        {
          icon: "icon-dayin-dayinji",
          name: this.$t("Toolbar.Print"),
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: this.$t("Toolbar.Share"),
          disabled: true,
        },
      ];
    },
    showDot() {
      return (value) => {
        if (value === "绿") {
          return "#3fb92f";
        } else if (value === "黄") {
          return "#ff8200";
        } else if (value === "红") {
          return "#ec1a1a";
        } else {
          return "#999999";
        }
      };
    },
  },
  methods: {
    // 工具栏
    // 获取显示工具列表
    getqueryListAPI() {
      getqueryList().then((res) => {});
    },
    // 排序字段
    getProductSortAPI() {
      if (this.isCompanyOrProduct) {
        getProductSortByColumns().then((res) => {
          this.sortList = [
            {
              value: "ASC",
              label: this.$t("Toolbar.ascending"),
              disabled: false,
              children:
                res?.data.map((item) => {
                  return { value: item.sortName, label: item.screenName };
                }) || [],
            },
            {
              value: "DESC",
              label: this.$t("Toolbar.descending"),
              disabled: false,
              children:
                res?.data.map((item) => {
                  return { value: item.sortName, label: item.screenName };
                }) || [],
            },
          ];
        });
      } else {
        let sortLocal = [
          {
            value: "company_name_en",
            label: this.$t("Relationship.CompanyName"),
          },
          {
            value: "company_country",
            label: this.$t("Relationship.Country"),
          },
          {
            value: "isic_en",
            label: this.$t("Relationship.Industry"),
          },
          {
            value: "company_type_code",
            label: this.$t("Relationship.CompanyType"),
          },
          {
            value: "scale_code",
            label: this.$t("Relationship.CompanySize"),
          },
          {
            value: "status",
            label: this.$t("Relationship.CompanyStatus"),
          },
          {
            value: "listing_status_code",
            label: this.$t("Relationship.ListingInfo"),
          },
          {
            value: "incorporation_year",
            label: this.$t("Relationship.IncDate"),
          },
        ];

        this.sortList = [
          {
            value: "ASC",
            label: this.$t("Toolbar.ascending"),
            disabled: false,
            children: sortLocal,
          },
          {
            value: "DESC",
            label: this.$t("Toolbar.descending"),
            disabled: false,
            children: sortLocal,
          },
        ];
      }
    },
    // 头部检索
    onSearch(params, type) {
      // 如果 query 完全一致，直接 return
      // if (
      //   params.searchKeyword == this.$route.query.keyword &&
      //   type == this.$route.query.selectKey
      // ) {
      //   return;
      // }

      if (type == this.$route.query.selectKey) {
        this.$router.replace({
          path: "/ubo/list",
          query: {
            keyword: params.searchKeyword,
            selectKey: type,
          },
        });
        this.clearParams();
      } else {
        let routeData = this.$router.resolve({
          path: "/ubo/list",
          query: {
            keyword: params.searchKeyword,
            selectKey: type,
          },
        });

        window.open(routeData.href, "_blank");
      }
    },
    // 排序
    onChangeSort(e) {
      console.log(1111, e);
      this.searchParams.pag = 1;
      this.searchParams.pageSize = 20;
      this.tableData = [];
      this.searchParams.sortType = e[0];
      this.searchParams.sortColumn = e[1];
      this.getPageList();
    },
    // 清空
    clearParams() {
      this.searchParams = {
        page: 1,
        pageSize: 20,
        companyName: "",
        country: "",
        industry: [],
        hsCode: "",
        importOrExport: [],
        companyType: [],
        companySize: [],
        companyStatus: [],
        listedCompany: [],
        yearsInBusiness: [],
        sortColumn: "",
      };
      this.tableData = [];

      this.searchParams.pag = 1;
      this.searchParams.pageSize = 20;
      this.getPageList();
      this.getFilterOptions();
    },
    menuClick(item, isActive) {
      console.log(11111, item, isActive);
      switch (item.name) {
        case "Select":
          if (isActive == "") {
            this.selectList = [];
            this.onSelectionChange([]);
            this.$refs.tableRefCompany.clearSelection();
          }
          break;
      }
    },
    // 检索
    onChangeParams() {
      console.log(3333, this.searchParams);
      this.tableData = [];
      this.searchParams.page = 1;
      this.searchParams.pageSize = 20;
      this.getPageList();
      this.getFilterOptions();
    },
    // 表格滚动
    handleScroll() {
      if (this.hasMore && !this.loading) {
        this.loadData();
      }
    },
    // 加载数据
    loadData() {
      let totalPage = Math.ceil(this.total / this.searchParams.pageSize);
      if (this.searchParams.page == totalPage) {
        this.hasMore = false;
      } else {
        this.searchParams.page += 1;
        this.getPageList();
      }
      console.log(111);
    },
    // 一览
    async getPageList() {
      this.loading = true;
      let searUrl = null;
      let params = {};
      this.expandedRowKeys = [];
      // 查产品
      if (this.isCompanyOrProduct) {
        searUrl = getProductSearch;
        params = {
          page: this.searchParams.page,
          pageSize: this.searchParams.pageSize,
          productKeyword: this.$route.query.keyword,
          productCode: this.searchParams.hsCode,
          aaaid: this.searchParams.companyName,
          industry_code: this.searchParams.industry[1],
          countryCode: this.searchParams.country,
          companyTypes: this.searchParams.companyType[0],
          companySizes: this.searchParams.companySize[0],
          companyStatuses: this.searchParams.companyStatus[0],
          listedStatuses: this.searchParams.listedCompany[0],
          importOrExportType: this.searchParams.importOrExport[0],
          timePeriod: this.searchParams.yearsInBusiness[0],
          sortType: this.searchParams.sortType,
          sortColumn: this.searchParams.sortColumn,
        };
      } else {
        // 查公司
        searUrl = getCompanySearch;
        params = {
          company_name: this.$route.query.keyword,
          page: this.searchParams.page,
          pageSize: this.searchParams.pageSize,
          searchType: 2,
          company_country: this.searchParams.country,
          isic_code: this.searchParams.industry[1],
          company_class_code: this.searchParams.companyType[0],
          scale_code: this.searchParams.companySize[0],
          reg_status: this.searchParams.companyStatus[0],
          listing_status_code: this.searchParams.listedCompany[0],
          years: this.searchParams.yearsInBusiness[0],
          sortType: this.searchParams.sortType,
          sortColumn: this.searchParams.sortColumn,
        };
      }

      let res = await searUrl(params);
      // 在这里调用API获取数据，并更新tableData和total

      if (res.code == 200) {
        // 将新数据添加到现有数据
        this.hasMore = true;
        this.total = res.data?.total;
        let rows = res.data?.rows ?? [];
        this.tableData = [...this.tableData, ...rows];
      }
      this.loading = false;
    },
    // 筛选条件
    async getFilterOptions() {
      let searUrl = null;
      let params = {};

      // 查产品
      if (this.isCompanyOrProduct) {
        searUrl = getProductFilter;
        params = {
          productKeyword: this.$route.query.keyword,
          productCode: this.searchParams.hsCode,
          aaaid: this.searchParams.companyName,
          industry_code: this.searchParams.industry[1],
          countryCode: this.searchParams.country,
          companyTypes: this.searchParams.companyType[0],
          companySizes: this.searchParams.companySize[0],
          companyStatuses: this.searchParams.companyStatus[0],
          listedStatuses: this.searchParams.listedCompany[0],
          importOrExportType: this.searchParams.importOrExport[0],
          timePeriod: this.searchParams.yearsInBusiness[0],
        };
      } else {
        // 查公司
        searUrl = getCompanyFilter;
        params = {
          company_name: this.$route.query.keyword,
          company_country: this.searchParams.country,
          industry_en: this.searchParams.industry[1],
          company_class_code: this.searchParams.companyType[0],
          searchType: 2,
          scale_code: this.searchParams.companySize[0],
          reg_status: this.searchParams.companyStatus[0],
          listing_status_code: this.searchParams.listedCompany[0],
          years: this.searchParams.yearsInBusiness[0],
        };
      }
      let res = await searUrl(params);

      if (res.code == 200) {
        this.companyList = res.data.companyNameList || [];
        this.productList = res.data.productThirdList || [];
        this.importOrExportList = res.data.ieEnumList || [];
        this.countryList =
          res.data?.geographicalLocation.map((item) => {
            return {
              name: this.isCompanyOrProduct
                ? this.getCountry(item.companyCountry.name)
                : item.companyCountry.name,
              value: item.companyCountry.value,
              count: item.companyCountry.count,
            };
          }) || [];
        this.industryList =
          res.data?.industry.map((item) => {
            return {
              label: item.name,
              value: item.value,
              children: item?.children.map((list) => {
                return {
                  label: list.name,
                  value: list.value,
                  count: list.count,
                };
              }),
            };
          }) || [];
        this.companyTypeList = res.data.companyTypeList || [];
        this.companySizeList = res.data.companySizeList || [];
        this.companyStatusList = res.data.regStatus || [];
        this.listedCompanyList = res.data.listingStatusList || [];
        this.yearsInBusinessList = res.data.yearsOfEstablishment || [];
      }
    },

    // 表格展开
    onRowExpansion(row) {
      console.log(1111, row);
      this.childParam.page = 1;
      this.$emit("selectTwoRow", []); //展开时清空所有选择项
      // 如果展开的行已存在于 expandedRowKeys 数组中，则关闭所有行
      if (this.expandedRowKeys.includes(row.aaa_id)) {
        this.expandedRowKeys = [];
      } else {
        // 否则只展开当前行
        this.expandedRowKeys = [row.aaa_id];

        this.childTableData = [];
        this.childParam.branchflag = row.aaa_id;
        this.getChildTableList();
      }
    },
    // 展开表格查询
    async getChildTableList() {
      this.childLoading = true;
      let res = await getCompanySearch(this.childParam);
      if (res) {
        this.childTableData = res.data.rows;
        this.childParam.total = res.data.total;
        this.childLoading = false;
      }
    },
    // 子表格翻页
    onChangePage(pagParm) {
      console.log(1111, pagParm);
      this.childParam.page = pagParm.page;
      this.childParam.pageSize = pagParm.pageSize;
      this.getChildTableList();
    },
    // 表格模式行选择改变时
    onSelectionChange(val) {
      this.selectList = val;
      if (val.length > 0) {
        this.tollbarList.forEach((item) => {
          switch (item.name) {
            case "Export":
              item.disabled = true;
              break;
            case "Collect":
              item.disabled = true;
              break;
          }
        });
      } else {
        this.tollbarList.forEach((item) => {
          switch (item.name) {
            case "Export":
              item.disabled = true;
              break;
            case "Collect":
              item.disabled = true;
              break;
          }
        });
      }
    },

    // // 公司搜索
    // async companyMethod(query) {
    //   this.companyList = [

    //   ];
    // },
    // // 公司聚焦时
    // onFocusCompany(val) {
    //   if (val) {
    //     this.companyList = [

    //     ];
    //   }
    // },
    // 跳转ubo详细
    goDetail(row) {
      let routeData = this.$router.resolve({
        path: "/ubo/detail",
        query: {
          id3a: row.aaa_id,
          keyword: row.name,
          selectKey: this.$route.query.selectKey,
        },
      });
      window.open(routeData.href, "_blank");
    },
    fixChildTable() {
      const table = this.$refs.tableRefCompany;
      const childTable = this.$refs.tableRefChild;
      childTable.columns.find(
        (column) => column.label === "Company Name",
      ).width =
        table.columns.find((column) => column.label === "Company Name").width +
        12;
      childTable.columns.find((column) => column.label === "Country").width =
        table.columns.find((column) => column.label === "Country").width;
      childTable.columns.find((column) => column.label === "Industry").width =
        table.columns.find((column) => column.label === "Industry").width;
      childTable.columns.find((column) => column.label === "Co. Typee").width =
        table.columns.find((column) => column.label === "Co. Type").width;
      childTable.columns.find(
        (column) => column.label === "Company Size",
      ).width = table.columns.find(
        (column) => column.label === "Company Size",
      ).width;
      childTable.columns.find(
        (column) => column.label === "Company Status",
      ).width = table.columns.find(
        (column) => column.label === "Company Status",
      ).width;
      childTable.columns.find(
        (column) => column.label === "Listing Info",
      ).width = table.columns.find(
        (column) => column.label === "Listing Info",
      ).width;
      childTable.columns.find(
        (column) => column.label === "Years in Business",
      ).width =
        table.columns.find((column) => column.label === "Years in Business")
          .width - 12;
      this.$refs.tableRefChild.doLayout();
    },
  },
  mounted() {
    this.getPageList();
    this.getFilterOptions();
    this.getqueryListAPI();
    this.getProductSortAPI();
    this.$nextTick(() => {
      this.fixChildTable();
    });
  },
};
</script>
<style></style>
<style scoped>
.UBO .page-top-con {
  background: #603c2c !important;
}
.UBO .header_menu_box {
  box-shadow: 0px 2px 4px 0px rgba(109, 133, 144, 0.3) !important;
}
.UBO .header_menu_box >>> .tollbar-con-filter-btn {
  background: #603c2c !important;
}
</style>
